import { FormField, inputClass } from "./FormField";

export type ForfaitPreview = {
  nb_familles?: number;
  nb_employes?: number;
  tarif_unitaire?: number;
  tarif_client?: number;
  effectif_scope?: string;
};

type ForfaitQuantityFieldsProps = {
  preview: ForfaitPreview | null | undefined;
  nbPrestataire: string;
  nbClient: string;
  onNbPrestataireChange: (value: string) => void;
  onNbClientChange: (value: string) => void;
};

function formatUsd(value: number) {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(value);
}

export function ForfaitQuantityFields({
  preview,
  nbPrestataire,
  nbClient,
  onNbPrestataireChange,
  onNbClientChange,
}: ForfaitQuantityFieldsProps) {
  const nbAuto = preview?.nb_familles ?? preview?.nb_employes ?? 0;
  const tarifPresta = preview?.tarif_unitaire ?? 0;
  const tarifClient =
    (preview?.tarif_client ?? 0) > 0 ? (preview?.tarif_client ?? 0) : tarifPresta;
  const nbP = Number(nbPrestataire) || 0;
  const nbC = Number(nbClient) || nbP;
  const totalPresta = Math.round(nbP * tarifPresta * 100) / 100;
  const totalClient = Math.round(nbC * tarifClient * 100) / 100;
  const scopeLabel =
    preview?.effectif_scope === "prestataire"
      ? "familles rattachées à ce prestataire"
      : "employés actifs entreprise";

  return (
    <div className="space-y-4 rounded-xl border border-primary/20 bg-primary-soft/40 p-4">
      <p className="text-sm text-foreground">
        Montants recalculés côté serveur. Le montant prestataire et le montant client (entreprise)
        peuvent différer.
      </p>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <FormField label="Qté facture prestataire" required>
          <input
            type="number"
            min={1}
            step={1}
            value={nbPrestataire}
            onChange={(e) => onNbPrestataireChange(e.target.value)}
            className={inputClass}
          />
          <p className="mt-1 text-xs text-muted">
            Proposition système : {nbAuto} {scopeLabel}.
          </p>
        </FormField>
        <FormField label="Qté facture client (entreprise)" required>
          <input
            type="number"
            min={1}
            step={1}
            value={nbClient}
            onChange={(e) => onNbClientChange(e.target.value)}
            className={inputClass}
          />
          <p className="mt-1 text-xs text-muted">
            {nbC !== nbP
              ? `Différente de la qté prestataire (${nbP}).`
              : "Quantité facturée à l'entreprise."}
          </p>
        </FormField>
      </div>
      <div className="grid grid-cols-1 gap-3 text-sm md:grid-cols-2">
        <div className="rounded-lg border border-border bg-card px-3 py-2">
          <div className="text-xs text-muted">Tarif prestataire</div>
          <div className="font-semibold text-foreground">{formatUsd(tarifPresta)} / famille</div>
          <div className="mt-1 text-muted">Total prestataire : {formatUsd(totalPresta)}</div>
        </div>
        <div className="rounded-lg border border-border bg-card px-3 py-2">
          <div className="text-xs text-muted">Tarif client convention</div>
          <div className="font-semibold text-foreground">{formatUsd(tarifClient)} / famille</div>
          <div className="mt-1 text-muted">Total client : {formatUsd(totalClient)}</div>
        </div>
      </div>
    </div>
  );
}
